import { useZeissFeatureFlags } from '../../hooks';

export const ZeissFeatureFlagsProvider = () => {
  useZeissFeatureFlags();

  return <></>;
};
